var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { key: _vm.renderId, staticClass: "dynamic-button-message-editor w-100" },
    [
      _c(
        "div",
        { staticClass: "mb-2 w-100" },
        [
          _c(
            "div",
            {
              staticClass: "mb-1",
              staticStyle: { color: "#475e7a", "font-weight": "600" },
            },
            [_vm._v("Data Source:")]
          ),
          _vm._v(" "),
          _c("TiptapEditor", {
            attrs: {
              placeholder: "Enter data source attribute",
              "show-attributes": true,
              "whatsapp-mode": false,
              "allowed-attributes": _vm.allowedAttributes,
              "preview-mode": _vm.previewMode,
            },
            model: {
              value: _vm.clone.dataSource,
              callback: function ($$v) {
                _vm.$set(_vm.clone, "dataSource", $$v)
              },
              expression: "clone.dataSource",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "button-editor-wrapper" }, [
        _c("div", { staticClass: "text-editor-wrapper" }, [
          _c(
            "div",
            { staticClass: "text-editor" },
            [
              _c("TiptapEditor", {
                attrs: {
                  placeholder: _vm.$t("chatbotv2.enterYourMessage"),
                  "show-attributes":
                    _vm.showAttributes === undefined ||
                    _vm.showAttributes === true,
                  "show-emoji":
                    _vm.showEmoji === undefined || _vm.showEmoji === true,
                  "max-character-count": 640,
                  "whatsapp-mode": _vm.whatsappMode,
                  "allowed-attributes": _vm.allowedAttributes,
                  "preview-mode": _vm.previewMode,
                },
                model: {
                  value: _vm.clone.message,
                  callback: function ($$v) {
                    _vm.$set(_vm.clone, "message", $$v)
                  },
                  expression: "clone.message",
                },
              }),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "buttons-wrapper" }, [
          _c(
            "div",
            { staticClass: "button-item" },
            [
              _c(
                "a-popover",
                {
                  attrs: {
                    visible: _vm.editingButtonPopupVisible,
                    placement: "left",
                    trigger: "click",
                    overlayClassName: "no-padding",
                  },
                  on: { visibleChange: _vm.visibleChange },
                },
                [
                  _c(
                    "div",
                    { attrs: { slot: "content" }, slot: "content" },
                    [
                      _c("ActionButtonUpdater", {
                        attrs: {
                          "on-completed": _vm.onButtonUpdateCompleted,
                          "popup-visible": _vm.editingButtonPopupVisible,
                          flattedDiagram: _vm.flattedDiagram,
                          "whatsapp-mode": _vm.whatsappMode,
                          "allowed-attributes": _vm.allowedAttributes,
                          "dynamic-button-message-editor": true,
                          allowedMessageTypes: ["SEND_MESSAGE"],
                        },
                        model: {
                          value: _vm.clone.buttonTemplate,
                          callback: function ($$v) {
                            _vm.$set(_vm.clone, "buttonTemplate", $$v)
                          },
                          expression: "clone.buttonTemplate",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass:
                        "d-flex justify-content-center align-items-center w-100 h-100",
                    },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.clone.buttonTemplate.title) +
                          "\n                    "
                      ),
                    ]
                  ),
                ]
              ),
            ],
            1
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }